import { RegionContent } from "../../components/boundary"

export default function Region () {

  return (

    <>
        <RegionContent/>
    </>

  )

}